export default __webpack_public_path__ + "static/media/img2.f64e0727.jpg";